import { SOURCES } from '@/types/enums/common';

export const APPLY_CONFIRM_SOURCES = [SOURCES.TWOGIS];
